
import {mapFieldArrToObjSchema} from "../../validation/useValidation";

export const FormAttributeInit = {
    name: "",
    type: {name: 'text', id: 56},
    label: null,
    has_editor:null,
    description:''
};

const attributeValidationsArr = [
    ['name', 'string'],
    ['type', 'object'],
    ['label', 'string'],
    ['description', 'string'],
];


export const attributeValidations = mapFieldArrToObjSchema(attributeValidationsArr);